export const FIREBASE_INITIALIZED = 'FIREBASE_FIREBASE_INITIALIZED'
export const SET_PLAYER_LIST = 'FIREBASE_SET_PLAYER_LIST'
export const SET_PLAYERS_DATA = 'FIREBASE_SET_PLAYERS_DATA'
export const SET_ACTIVE_PLAYER_LIST = 'FIREBASE_SET_ACTIVE_PLAYER_LIST'
export const SET_LISTENER_TYPE = 'FIREBASE_SET_LISTENER_TYPE'
export const SET_GROUP_DATA = 'FIREBASE_SET_GROUP_DATA'
export const SET_USER_DATA = 'FIREBASE_SET_USER_DATA'
export const SET_FEDERATIONS_INFO = 'FIREBASE_SET_FEDERATIONS_INFO'

export const firebaseInitialized = (data) => {
  return { type: FIREBASE_INITIALIZED, data }
}
export const setPlayerList = (data) => {
  return { type: SET_PLAYER_LIST, data }
}

export const setFederationsInfo = (data) => {
  return { type: SET_FEDERATIONS_INFO, data }
}

export const setPlayersData = (data) => {
  return { type: SET_PLAYERS_DATA, data }
}
export const setListenerType = (name, storeName = 'userMap') => {
  return {
    type: SET_LISTENER_TYPE,
    data: {
      name: name,
      storeName: storeName,
    },
  }
}
export const setGroupData = (data) => {
  return { type: SET_GROUP_DATA, data: data }
}
export const setUserData = (data) => {
  return { type: SET_USER_DATA, data: data }
}
export const setActivePlayerList = (data) => {
  return { type: SET_ACTIVE_PLAYER_LIST, data }
}
